/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import { IResourceProps } from 'apmui/resource/ResourceLoader';
import { RESOURCE } from 'apmui/resource/ResourceType';
import { WebtopResourceModel } from 'apmui/resource/WebtopResourceModel';

class WebtopLinkModel extends WebtopResourceModel {
    // static
    static readonly propNames = ['application_uri', ...WebtopResourceModel.propNames];
    // instance
    type: RESOURCE.WEBTOP_LINK = RESOURCE.WEBTOP_LINK;
    applicationUri: string;

    constructor(id: string, resource: IResourceProps) {
        super(id, resource);
        this.applicationUri = resource.props.application_uri;
        this.undefinedIconToDefault();
    }

    getPropNames(): string[] {
        return WebtopLinkModel.propNames;
    }

    launchResource() {
        window.open(this.applicationUri, '_blank', '');
    }
}

export { WebtopLinkModel as default, WebtopLinkModel };
